/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-start-loading': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M.784.84h2.75a.5.5 0 0 1 .5.5v2.75a.5.5 0 0 1-.5.5H.784a.5.5 0 0 1-.5-.5V1.34a.5.5 0 0 1 .5-.5zm2.25 2.75V1.84h-1.75v1.75h1.75zM8.5 2.715H5.75a.5.5 0 0 0-.5.5v2.25H3a.5.5 0 0 0-.5.5v2.25H.556l-.1.008C.196 8.266 0 8.47 0 8.715c0 .277.249.5.556.5h8.888l.1-.008c.26-.042.456-.246.456-.492 0-.276-.249-.5-.556-.5H9v-5a.5.5 0 0 0-.5-.5zm-2.25 3.75H8v1.75H6.25v-1.75zM8 3.715v1.75H6.25v-1.75H8zm-2.75 4.5v-1.75H3.5v1.75h1.75z" _fill="#fff"/>'
  }
})
